<template>
  <div>
    <!-- TRANSMITTED -->
    <TransmittedSettlement
        v-if="activeView === 'transmitted'"
        :filter="filter"
        @showInProgress="activeView = 'inProgress'"
        @changeTab="forwardChangeTab"
    />

    <!-- IN PROGRESS -->
    <ProgressSettlement
        v-else
        :filter="filter"
        @goBack="activeView = 'transmitted'"
        @changeTab="forwardChangeTab"
    />
  </div>
</template>

<script>
import TransmittedSettlement from "@/pages/dashboard/settlements/aggregate/tabs/main-listing/TransmittedSettlement.vue";
import ProgressSettlement from "@/pages/dashboard/settlements/aggregate/tabs/main-listing/ProgressSettlement.vue";

export default {
  components: {ProgressSettlement, TransmittedSettlement},
  props:['filter'],
  data() {
    return {
      activeView: 'transmitted'
    }
  },
  methods: {
    forwardChangeTab(tab) {
      this.$emit('changeTab', tab)
    }
  }
}
</script>
